import { Dialog, DialogContent, DialogTitle, MenuItem, Select } from "@mui/material";
import { RadioBtnDialogModel } from "../../Utilities/Models/ConstantModels";
import "../RadioBtnDialog/RadioBtnDialog.scss";
import close from "../../../Assets/bulkUploadDialog/close.svg";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../Utilities/Constants/ApiEndpoints";
import {
  API_RESPONSE,
  LANGUAGES,
  LAYOUTS,
  TOASTER_CONFIGS,
} from "../../Utilities/Constants/Constants";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
const ThemeParkPromotionDialog = (dialogData: RadioBtnDialogModel) => {
  const { isOpen, onCloseDialog } = dialogData;
  const [themeParkId, setThemeParkId] = useState<string>("");
  const [themeParkValue, setThemeParkValue] = useState<string>("");
  const [dropDownTP, setdropDownTP] = useState<any[]>([]);
  const [orderthemePark, setorderThemePark] = useState<any[]>([]);
  const [orderId, setOrderId] = useState<string>("");
  const [cities, setCities] = useState<any[]>([]);
  const [selectedCity, setSelectedCity] = useState<string>("");
  const [allOrderNumbers, setAllOrderNumbers] = useState<number[]>([]);
  const [availableOrderNumbers, setAvailableOrderNumbers] = useState<number[]>([]);
  const language = useSelector((state: any) => state.languageReducer.language);
  const getAllThemeparkList = (city?: string) => {
    const params = city ? { city } : {};
    axiosInstance.get(API_END_POINTS.THEME_PARK_ORDER, { params }).then((res) => {
      if (res.data.status === API_RESPONSE.TRUE) {
        const data = res.data.result.data;
        setorderThemePark(data.ordered_data);
        setdropDownTP(data.dropdown_data);
        setCities(data.city_data);
        const count = data.count || 0;
        const allNumbers = Array.from({ length: count }, (_, i) => i + 1);
        const usedNumbers = data.ordered_data.map((item: any) => item.order);
        const availableNumbers = allNumbers.filter(num => !usedNumbers.includes(num));
        setAllOrderNumbers(allNumbers);
        setAvailableOrderNumbers(availableNumbers);
        if (city && data.dropdown_data.length === 0 && data.ordered_data.length > 0) {
          toast.info(`All theme parks in ${city} have been assigned orders`, TOASTER_CONFIGS);
        }
      }
    });
  };
  const PostThemeparkData = (payload: any) => {
    axiosInstance.post(API_END_POINTS.THEME_PARK_ORDER, payload)
      .then((res) => {
        if (res.data.status === API_RESPONSE.TRUE) {
          getAllThemeparkList(selectedCity);
          setThemeParkValue("");
          setOrderId("");
          toast.success("Order assigned successfully", TOASTER_CONFIGS);
        }
      })
      .catch((error) => {
        toast.error(error.message || "Error assigning order", TOASTER_CONFIGS);
      });
  };
  const DeleteThemeparkData = (payload: any) => {
    axiosInstance.put(API_END_POINTS.THEME_PARK_ORDER, payload)
      .then(() => {
        getAllThemeparkList(selectedCity);
        toast.success("Order removed successfully", TOASTER_CONFIGS);
      })
      .catch((error) => {
        toast.error(error.message || "Error removing order", TOASTER_CONFIGS);
      });
  };
  useEffect(() => {
    if (isOpen) {
      getAllThemeparkList();
    }
  }, [isOpen]);
  useEffect(() => {
    if (selectedCity) {
      getAllThemeparkList(selectedCity);
    } else {
      
      setdropDownTP([]);
      setorderThemePark([]);
      setAllOrderNumbers([]);
      setAvailableOrderNumbers([]);
    }
  }, [selectedCity]);
  const handleCityChange = (e: any) => {
    const cityValue = e.target.value;
    setSelectedCity(cityValue);
    setThemeParkValue("");
    setOrderId("");
    
    if (!cityValue || cityValue.toLowerCase() === 'select cities') {
      setdropDownTP([]);
      setorderThemePark([]);
      setAllOrderNumbers([]);
      setAvailableOrderNumbers([]);
    }
  };
  const handleThemeParkChange = (e: any) => {
    setThemeParkValue(e.target.value);
    const park = dropDownTP.find((p: any) => p.id === e.target.value);
    setThemeParkId(park?.id || "");
    setOrderId("");
  };
  const handleOrderChange = (e: any) => {
    setOrderId(e.target.value);
  };
  const closeDialog = () => {
    setSelectedCity("");
    setThemeParkValue("");
    setOrderId("");
    onCloseDialog();
  };
  const filteredThemeParks = selectedCity
    ? dropDownTP.filter((park: any) => park.city === selectedCity)
    : [];
  return (
    <Dialog
      open={isOpen}
      onClose={closeDialog}
      fullWidth
      maxWidth="md"
      dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
      className="theme-park-dialog"
    >
      <DialogTitle className="dialog-header">
        <img src={close} style={{
          position: 'absolute',  
          top: '10px',           
          right: '20px',         
          cursor: 'pointer',     
        }} alt="Close" onClick={closeDialog} />
        <h3>Theme Park Promotional Order</h3>
      </DialogTitle>
      <DialogContent>
        <div className="row school-row-wrap">
          <div className="programs-options-wrapper">
            <div className="dropdown-container">
              <label>City</label>
              <Select
                value={selectedCity}
                onChange={handleCityChange}
                displayEmpty
                fullWidth
              >
                <MenuItem value="">Select Cities</MenuItem>
                {cities.map((city: any) => (
                  <MenuItem key={city.city} value={city.city}>
                    {city.city}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="dropdown-container">
              <label>Theme Park</label>
              <Select
                value={themeParkValue}
                onChange={handleThemeParkChange}
                displayEmpty
                fullWidth
                disabled={!selectedCity || selectedCity.toLowerCase() === 'select cities'}
              >
                <MenuItem value="">Select Theme Park</MenuItem>
                {filteredThemeParks.map((park: any) => (
                  <MenuItem key={park.id} value={park.id}>
                    {park.themepark_name}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="dropdown-container">
              <label>Order Number</label>
              <Select
                value={orderId}
                onChange={handleOrderChange}
                displayEmpty
                fullWidth
                disabled={!themeParkValue}
              >
                <MenuItem value="">Select Order</MenuItem>
                {availableOrderNumbers.map((num) => (
                  <MenuItem
                    key={num}
                    value={num}
                    disabled={orderthemePark.some(p => p.order === num)}
                  >
                    {num} {orderthemePark.some(p => p.order === num) ? "(Assigned)" : ""}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => PostThemeparkData([{ themepark_id: themeParkId, order: orderId }])}
              disabled={!themeParkId || !orderId}
            >
              Add
            </button>
          </div>
          <div className="event-wrap">
            <table>
              <thead>
                <tr>
                  <th>City</th>
                  <th>Theme Park</th>
                  <th>Order</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {orderthemePark.length > 0 ? (
                  orderthemePark
                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                    .map((park) => (
                      <tr key={park.id}>
                        <td>{park.city}</td>
                        <td>{park.themepark_name}</td>
                        <td>{park.order}</td>
                        <td>
                          <DeleteIcon
                            onClick={() => DeleteThemeparkData([{ themepark_id: park.id, order: "" }])}
                          />
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={4} className="no-orders">No orders assigned yet</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default ThemeParkPromotionDialog;